/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lime_Loose_Ocelot_LeapInputs */

const fr_lime_loose_ocelot_leap = /** @type {(inputs: Lime_Loose_Ocelot_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type d'abonnement`)
};

/**

* @param {Lime_Loose_Ocelot_LeapInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lime_loose_ocelot_leap = /** @type {((inputs?: Lime_Loose_Ocelot_LeapInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lime_Loose_Ocelot_LeapInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lime_loose_ocelot_leap(inputs)
});